import React from 'react';
import PropTypes from 'prop-types';
import { SpacerVertical, Typography } from '@klarna/bubble-ui';

import { tPrefix as tPrefixDocumentUpload } from '../DocumentUpload/constants';
import { DocumentList } from './DocumentList';

export const BusinessDocuments = ({ documents = [], t }) =>
  documents.length > 0 && (
    <>
      <Typography textToken="text-style/headings/titles/bold/grande">
        {t(`${tPrefixDocumentUpload}.business_documents`)}
      </Typography>
      <SpacerVertical extraSmall />
      <DocumentList documents={documents} />
    </>
  );

BusinessDocuments.propTypes = {
  t: PropTypes.func.isRequired,
  documents: PropTypes.array,
};
